<template>
  <div class="main-border"><!-- 后台 -->
    <el-menu default-active="3" class="el-menu-demo" mode="horizontal">
      <div class="addAdminButton">
        <el-button size="mini" type="success" @click="dialogFormVisible = true" > 添加管理员</el-button>
        <el-dialog title="新增管理员" :visible.sync="dialogFormVisible" v-reset-form="dialogFormVisible" width="27%">
          <el-form ref="form" :model="form" label-width="80px">
            <el-form-item label="账号">
              <el-input v-model="form.account"></el-input>
            </el-form-item>
            <el-form-item label="姓名">
              <el-input v-model="form.name"></el-input>
            </el-form-item>
            <el-form-item label="角色">
              <el-checkbox v-model="form.roleIds" v-for="role in roleList" :label="role.id"
                           :key="role.id">
                <span @mouseenter="role.showInfo = true" @mouseleave="role.showInfo = false">
                  {{ role.name }}
                  <el-tooltip v-if="role.showInfo" :content="role.info" placement="top" effect="light">
                    <i class="el-icon-info" style="margin-left: 5px;"></i>
                  </el-tooltip>
                </span>
              </el-checkbox>
            </el-form-item>
            <el-form-item>
              <el-button type="primary" @click="saveAdmin(0)">保存</el-button>
              <el-button @click="dialogFormVisible=false">取消</el-button>
            </el-form-item>
          </el-form>
        </el-dialog>
      </div>
    </el-menu>
    <el-table :data="userManage" stripe style="width: 100%;color: #5a5c61;">
      <el-table-column prop="account" label="管理员账号" show-overflow-tooltip width="180"></el-table-column>
      <el-table-column prop="name" label="管理员名称" width="180"></el-table-column>
      <el-table-column prop="roleList" label="管理员类型" min-width="180">
        <template slot-scope="scope">
          <span v-if="scope.row.type === 0">超级管理员</span>
          <span v-else>
            <span v-for="(role, index) in scope.row.roleList" :key="role.id">
            {{ role.name }}
            <span v-if="index < scope.row.roleList.length - 1">,</span>
          </span>
          </span>
        </template>
      </el-table-column>
      <el-table-column prop="operTime" label="创建时间" min-width="250" align="center"></el-table-column>
      <el-table-column label="操作"  width="455">
        <template slot-scope="scope">
          <el-button size="mini" @click="openDeleteDialog(scope.row.id)" type="danger" :disabled="scope.row.type === 0">
            删除管理员
          </el-button>
          <el-button size="mini" @click="openUpdateDialog(scope.row)" type="danger" :disabled="scope.row.type === 0">
            修改权限
          </el-button>
          <el-button size="mini" @click="resetPassword(scope.row.id)" type="danger" :disabled="scope.row.type === 0">
            重置密码
          </el-button>
        </template>
      </el-table-column>
    </el-table>
    <el-dialog title="管理员权限修改" :visible.sync="dialogUpdateVisible" width="30%" :append-to-body="true">
      <el-form ref="form" :model="form" label-width="80px">
        <el-form-item label="账号">
          <el-input v-model="form.account" disabled></el-input>
        </el-form-item>
        <el-form-item label="姓名">
          <el-input v-model="form.name"></el-input>
        </el-form-item>
        <el-form-item label="角色">
          <el-checkbox v-model="form.roleIds" v-for="role in roleList" :label="role.id"
                       :key="role.id">{{ role.name }}
          </el-checkbox>
        </el-form-item>
        <el-form-item>
          <el-button type="primary" @click="saveAdmin()">保存</el-button>
          <el-button @click="dialogUpdateVisible=false">取消</el-button>
        </el-form-item>
      </el-form>
    </el-dialog>
    <div class="block">
      <el-pagination
          @size-change="handleSizeChange"
          @current-change="handleCurrentChange"
          background
          :current-page="nowPage"
          :page-sizes="[8,16,24,32]"
          :page-size="nowSize"
          layout="total, sizes, prev, pager, next, jumper"
          :total="total">
      </el-pagination>
    </div>
  </div>
</template>

<script>
export default {
  name: "userList",
  created() {
    this.getUserManage();
    this.$api.findRoles().then((res) => {
      if (res.code == 200) {
        this.roleList = res.data;
      }
    })
  },
  methods: {
    handleSizeChange(val) {
      this.nowSize = val;
      this.getUserManage();
    },
    handleCurrentChange(val) {
      this.nowPage = val;
      this.getUserManage();
    },
    openDeleteDialog(id) {
      this.$confirm('您确定要删除该用户吗?', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(() => {
        this.$api.deleteAdminById({id: id}).then((res) => {
          this.$message({
            message: res.message,
            type: 'success'
          }); //提示
          this.getUserManage();
        })
      })
    },
    //重置密码
    resetPassword(id) {
      this.$confirm('您确定要重置该用户密码吗?', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(() => {
        this.$api.resetPassword({id: id}).then((res) => {
          if (res.code == 200) {
            this.$message({
              message: res.message,
              type: 'success'
            }); //提示
          } else {
            this.$message({
              message: res.message,
              type: 'error'
            })
          }
          this.getUserManage();
        })
      })
    },
    openUpdateDialog(row) {
      this.form.id = row.id;
      this.form.account = row.account;
      this.form.name = row.name;
      this.dialogUpdateVisible = true;
    },
    getUserManage() {
      //管理员
      this.$api.getUserManage({
        page: this.nowPage,
        nums: this.nowSize,
      }).then(res => {
        if (res.code == 200) {
          this.userManage = res.data.list;
          this.total = res.data.total;
        }
      })
    },
    saveAdmin(val) {
      event.stopPropagation();
      if (this.form.roleIds.length == 0) {
        this.$message({
          message: '未选择角色',
          type: 'error'
        })
        return;
      }
      if (this.form.name == "") {
        this.$message({
          message: '未输入姓名',
          type: 'error'
        })
        return;
      }
      if (this.form.account == "") {
        this.$message({
          message: '请输入账号',
          type: 'error'
        })
      }
      if (val) {
        this.form.id = "";
      }
      this.$api.saveAdmin(this.form).then((res) => {
        if (res.code == 200) {
          this.$message({
            message: res.message,
            type: 'success'
          }); //提示
          //关闭对话框
          this.form = {
            id: "",
            account: "",
            gender: "",
            phone: "",
            name: "",
            address: "",
            roleIds: []
          }
          this.dialogFormVisible = false;
          this.dialogUpdateVisible = false;
          this.getUserManage();
        }
      })
    }
  },
  directives: {
    'reset-form': {
      bind(el, binding, vnode) {
        const vm = vnode.context;
        vm.$watch(binding.expression, (newVal) => {
          if (newVal) {
            // 清空表单
            vm.form = {
              id: "",
              account: "",
              gender: "",
              phone: "",
              name: "",
              address: "",
              roleIds: []
            };
          }
        });
      }
    }
  },
  data() {
    return {
      nowPage: 1,
      nowSize: 8,
      total: 100,
      userManage: [],
      showInfo: false, // 控制信息显示状态
      dialogFormVisible: false,
      dialogUpdateVisible: false,
      dialogFormVisible2: false,
      roleList: [],
      form: {
        id: "",
        account: "",
        gender: "",
        phone: "",
        name: "",
        address: "",
        roleIds: []
      }
    }
  },
}
</script>

<style scoped>
.main-border {
  background-color: #FFF;
  padding: 10px 30px;
  box-shadow: 0 1px 15px -6px rgba(0, 0, 0, .5);
  border-radius: 5px;
}

.block {
  display: flex;
  justify-content: center;
  padding-top: 15px;
  padding-bottom: 10px;
  width: 100%;
}

.addAdminButton {
  display: flex;
  justify-content: flex-end;
  align-items: center;
  height: 60px;
  outline: none;
}
</style>